import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';

/**
 * @deprecated Since 2026-10-23. Use `infcW3hostnameInterceptor` from
 * `@infodata-group/inf-commons-core`.
 */
@Injectable()
export class W3hostnameInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const w3hostname = sessionStorage.getItem('w3hostname');
    if (w3hostname) {
      const newUrl = new URL(request.url, document.baseURI);
      newUrl.searchParams.delete('w3hostname');
      newUrl.searchParams.append('w3hostname', w3hostname);
      return next.handle(request.clone({ url: `${newUrl.pathname}${newUrl.search}`}));
    }
    return next.handle(request);
  }
}
